<div class="pdv-screen">

  <!-- ─────────── Cabeçalho ─────────── -->
  <header class="pdv-screen__topbar">
    <button type="button" class="pv2-icon-btn" (click)="voltar()">
      <span class="fa fa-arrow-left"></span>
    </button>
    <h2 class="pdv-screen__title">{{tituloPagina}}</h2>
    <span class="pdv-screen__total" *ngIf="pedido.total > 0">
      Total <strong>{{ pedido.total | currency:'BRL' }}</strong>
    </span>
  </header>

  <div class="pdv-screen__body">

    <!-- ─────────── Catálogo ─────────── -->
    <section class="pdv-screen__catalog">
      <app-tela-adicionar-produto-pdv #telaAdicionarProduto
        (onAdicionou)="adicioneProduto($event)"
        (onAtualizou)="atualizeProduto($event)"
        (onCancelouAdicionar)="canceleAdicionar($event)">
      </app-tela-adicionar-produto-pdv>
    </section>

    <!-- ─────────── Pedido ─────────── -->
    <aside class="pdv-screen__order">
      <form #frm="ngForm" class="pdv-order">

        <nav class="pdv-order__tabs">
          <button type="button" class="pdv-order__tab"
                  [class.is-active]="abaAtual === 'carrinho'"
                  (click)="voltarParaCarrinho()">
            <span class="fe-list"></span> Pedido
          </button>
          <button type="button" class="pdv-order__tab"
                  [class.is-active]="abaAtual === 'pagamento'"
                  (click)="irParaPagamento()"
                  [disabled]="pedido.itens.length === 0">
            <span class="fe-dollar-sign"></span> Pagamento
          </button>
        </nav>

        <!-- ─────────── Aba: carrinho ─────────── -->
        <div class="pdv-order__panel" *ngIf="abaAtual === 'carrinho'">

          <div class="pdv-order__client">
            <div class="pdv-segmented">
              <button type="button" class="pdv-segmented__btn"
                      [class.is-active]="pedido.balcao"
                      (click)="mudarTipoEntrega('BALCAO')">
                Balcão / Retirar
              </button>
              <button type="button" class="pdv-segmented__btn"
                      [class.is-active]="!pedido.balcao"
                      (click)="mudarTipoEntrega('ENTREGA')">
                Entrega
              </button>
            </div>

            <app-buscar-contato #buscarContato [borda]="true"
              (onBuscouContato)="contatoFoiBuscado($event)"
              [mensagem]="'Buscar Cliente (F2)'">
            </app-buscar-contato>

            <div class="pdv-order__delivery" *ngIf="!pedido.balcao">

              <div class="pdv-note" *ngIf="!contato.id">
                <span class="fa fa-user"></span>
                Identifique o cliente acima para configurar a entrega.
              </div>

              <ng-container *ngIf="contato.id">
                <div class="pdv-order__delivery-head">
                  <span>Endereço de entrega</span>
                  <button type="button" class="pdv-link-btn" (click)="novoEndereco()">+ Novo</button>
                </div>

                <div class="pdv-inline-field" *ngIf="enderecos.length > 0">
                  <kendo-dropdownlist
                    [data]="enderecos"
                    [textField]="'descricaoCompleta'"
                    [valueField]="'id'"
                    [(ngModel)]="pedido.entrega.endereco"
                    (valueChange)="selecionarEndereco($event)"
                    [ngModelOptions]="{standalone: true}">
                  </kendo-dropdownlist>
                  <button type="button" class="pv2-icon-btn pv2-icon-btn--sm"
                          (click)="editarEndereco()"
                          [disabled]="!pedido.entrega.endereco">
                    <span class="fa fa-edit"></span>
                  </button>
                </div>

                <div class="pdv-note pdv-note--warning" *ngIf="enderecos.length === 0">
                  Cliente sem endereço cadastrado.
                  <button type="button" class="pdv-link-btn" (click)="novoEndereco()">Cadastrar</button>
                </div>

                <div class="pdv-field pdv-field--compact" *ngIf="pedido.entrega.endereco">
                  <span class="pdv-field__label">Taxa de entrega</span>
                  <kendo-numerictextbox
                    [(ngModel)]="pedido.entrega.taxaDeEntrega"
                    (valueChange)="pedido.calculeTotal()"
                    [format]="'c2'"
                    [min]="0"
                    [spinners]="false"
                    [ngModelOptions]="{standalone: true}">
                  </kendo-numerictextbox>
                  <span *ngIf="calculandoTaxa" class="pdv-field__spinner">
                    <span class="fa fa-spin fa-spinner"></span>
                  </span>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="pdv-order__items">
            <app-grid-produtos #listaDePedidos [tela]="this" (onEditar)="editeItemPedido($event)"></app-grid-produtos>
          </div>

          <footer class="pdv-order__totals">
            <div class="pdv-order__total-line">
              <span>Subtotal</span>
              <span>{{ pedido.subTotal | currency:'BRL' }}</span>
            </div>
            <div class="pdv-order__total-line" *ngIf="pedido.entrega.taxaDeEntrega">
              <span>Taxa de entrega</span>
              <span>{{ pedido.entrega.taxaDeEntrega | currency:'BRL' }}</span>
            </div>
            <div class="pdv-order__total-line pdv-order__total-line--grand">
              <span>Total</span>
              <span>{{ pedido.total | currency:'BRL' }}</span>
            </div>
            <button type="button" class="pv2-primary-btn pv2-full-btn" (click)="irParaPagamento()">
              Pagamento (F9)
            </button>
          </footer>
        </div>

        <!-- ─────────── Aba: pagamento ─────────── -->
        <div class="pdv-order__panel" *ngIf="abaAtual === 'pagamento'">
          <div class="pdv-order__payment">

            <div class="pdv-cashback" *ngIf="pedido.cashback && obtenhaSaldoCartao() > 0">
              <div class="pdv-note pdv-note--success">
                <span class="fa fa-check"></span>
                Saldo de cashback: <strong>{{ obtenhaSaldoCartao() | currency:"BRL"}}</strong>
              </div>

              <label class="pdv-check">
                <input type="checkbox" id="usarCashback"
                       [checked]="usarSaldo" (change)="toggleUsarCashback(usarSaldo)">
                <span>Usar saldo para abater do valor total</span>
              </label>

              <div class="pdv-cashback__used" *ngIf="usarSaldo">
                Valor utilizado: <strong>{{ pedido.cashback.valor | currency:'BRL' }}</strong>
              </div>
            </div>

            <div class="pdv-field pdv-field--compact">
              <span class="pdv-field__label">Desconto (R$)</span>
              <kendo-numerictextbox [(ngModel)]="pedido.desconto" format="c2" [min]="0"
                                    (ngModelChange)="recalculeTotal()"
                                    [ngModelOptions]="{standalone: true}"
                                    [disabled]="pedido.obtenhaDescontosProdutos() > 0">
              </kendo-numerictextbox>
            </div>

            <div class="pdv-coupon" [hidden]="pedido.obtenhaDescontosProdutos()">
              <span class="pdv-field__label">Cupom promocional</span>
              <div class="pdv-inline-field">
                <label class="pv2-search">
                  <input type="text" placeholder="Código" [(ngModel)]="pedido.codigoCupom"
                         [ngModelOptions]="{standalone: true}"
                         [disabled]="aplicandoCupom || (pedido.cupom && pedido.cupom.brindeResgate)">
                </label>
                <button type="button" class="pv2-ghost-btn pv2-ghost-btn--compact" (click)="apliqueCupom()">
                  Aplicar
                </button>
              </div>
              <div *ngIf="erroCupom" class="pdv-coupon__error">{{erroCupom}}</div>
            </div>

            <div class="pdv-order__pay-total">
              <span>Total a pagar</span>
              <strong>{{ pedido.obtenhaValorAhPagar() | currency:'BRL' }}</strong>
            </div>

            <app-grid-pagamento #gridPagamentos
              [frm]="frm"
              (mudouFormaPagamento)="mudouFormaPagamento()"
              (alterouOpcaoMultiplasFormas)="alterouOpcaoMultiplasFormas()"
              (calculeTroco)="calculeTroco()"
              [totalPagar]="pedido.obtenhaValorAhPagar()"
              [totalProdutos]="pedido.obtenhaValorAhPagarProdutos()"
              [modoPdv]="true"
              [formasDePagamento]="formasDePagamento">
            </app-grid-pagamento>

            <div class="pdv-alert pdv-alert--danger" *ngIf="msgErro">{{ msgErro }}</div>
          </div>

          <footer class="pdv-order__totals">
            <button type="button" class="pv2-primary-btn pv2-full-btn" (click)="finalizarPedido()">
              <span class="fa fa-check"></span>
              Finalizar pedido
            </button>
          </footer>
        </div>

      </form>
    </aside>
  </div>
</div>
